import React, { Fragment, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Select, Progress, Tooltip, Spin, Dropdown, Tag, Checkbox, Drawer, Switch, DatePicker, Button, notification,
} from 'antd';
import {
  ControlOutlined, FilterOutlined, CaretDownFilled, UnlockOutlined, LockOutlined,
} from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faSquareArrowUpRight } from '@fortawesome/free-solid-svg-icons';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import SelectDepartment from '@Components/Common/SelectDepartment';
import { toISTDate } from '@Apis/constants';
import MrpV2Actions from '@Actions/production/mrpV2Actions';
import MOActions from '@Actions/moActions';
import SellerActions from '@Actions/sellerActions';
import H3DateSelector from '@Uilib/h3DateSelector';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const { Option } = Select;

const LinkManufacturingOrderMrp = ({
  user, history, mrpId, getMO, getMOLoading, getSellers, getSellersLoading, sellers, linkMoToMrp, linkMoToMrpLoading, tenantId, callback,
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState('');
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [scheduledStartDate, setScheduledStartDate] = useState('');
  const [scheduledEndDate, setScheduledEndDate] = useState('');
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState('');
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [moData, setMoData] = useState([]);
  const [call, setCall] = useState(false);

  useEffect(() => {
    getSellers('', tenantId, 1, 1000, '');
  }, []);

  const handleLinkMo = () => {
    const isLinkedMrp = 'false';
    getMO(tenantId, null, selectedStatus, 1, 1000, null, (_data) => setMoData(_data?.result?.manufacturing_orders?.filter((item) => !item?.mrp_id)), selectedSeller, selectedDepartment, Number(startDateMomentEpoch), Number(endDateMomentEpoch), 'true', 'false', '', scheduledStartDate, scheduledEndDate, isLinkedMrp);
  };

  const isRowDisabled = (record) => {
    let isDisable = false;
    if (user?.tenant_info?.production_config?.addons?.access_restriction?.is_active) {
      if ((record?.is_restricted && record?.mo_users?.includes(user?.user_id)) || (!record?.is_restricted && record?.mo_users === null)) {
        isDisable = false;
      } else isDisable = true;
    }
    return isDisable;
  };

  const statusOptions = [
    { label: 'Draft', value: 'DRAFT' },
    { label: 'Confirmed', value: 'CONFIRMED' },
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Void', value: 'VOID' },
    { label: 'Closed', value: 'COMPLETED' },
  ];

  const getMoColumns = () => {
    const moListColumns = [
      {
        title: '',
        render: (record) => {
          const { mo_finished_goods } = record;
          const getCompletionPercentage = () => parseInt(Number(((record?.total_issued_mofg_quantity / record.total_mofg_quantity) * 100)));
          return (
            <Link to={`/production/manufacturing-orders/view/${record.mo_id}`}>
              <div className="mo-list__mobile-item">
                <div style={{ display: 'flex' }}>
                  <H3Text text={`#${record?.mo_number}`} className="mo-list__mobile-item__mo-number" />
                  <div className="mo-list__mobile-item__status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                    {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  </div>
                </div>
                {
                  record?.tenant_seller_info && (
                    <div className="mo-list__mobile-item__info">
                      {`Subcontractor - ${record?.seller_name}`}
                    </div>
                  )
                }
                <H3Text text={`Department - ${record?.dept_alias_name}`} className="mo-list__mobile-item__info" />

                {!['DRAFT', 'VOID', 'CONFIRMED'].includes(record?.status) && (
                  <div className="mobile-list__item-completion">
                    <div style={{ fontSize: '11px', width: 'calc(100% - 110px)' }}>
                      <Progress
                        percent={getCompletionPercentage()}
                        status="active"
                        size="small"
                        strokeColor={{ from: '#108ee9', to: '#87d068' }}
                        trailColor="#2d7df71a"
                      />
                    </div>
                    <H3Text text="Completed" className="mobile-list__item-completion-text" />
                  </div>
                )}
                <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mo-list__mobile-item__footer" />
              </div>
            </Link>
          );
        },
        responsive: ['xs'],
      },
      {
        title: 'ORDER #',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        fixed: 'left',
        width: '140px',
        render: (record) => (
          <Fragment>
            <H3Text text={record?.mo_number} className="common-table-blue-text" />
            <div className="common-table-grey-subtext">
              <H3Text text={(record?.dept_alias_name ? `${record?.dept_alias_name}` : '')} />
            </div>
          </Fragment>
        ),
      },
      {
        title: 'SUB CONTRACTOR',
        render: (text, record) => (
          <div>
            {record?.linked_sales_orders?.length > 0 && (
              <Link
                to={`/sales/sales-order/view/${record?.linked_sales_orders?.[0]?.order_id}`}
                target="_blank"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  fontSize: '12px',
                  fontWeight: '500',
                  marginTop: '5px',
                }}
              >
                <FontAwesomeIcon icon={faLink} />
                <H3Text text={record?.linked_sales_orders?.[0]?.sales_order_number} />
              </Link>
            )}
            {
              record?.seller_name ? (
                <Fragment>
                  <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                    <span style={{ fontWeight: '600' }}>{record?.seller_name}</span>
                  </Link>
                  {record?.seller_address ? <H3Text text={record?.seller_address?.city} /> : ''}
                </Fragment>
              ) : '-'
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'ORDER STATUS',
        render: (item) => (
          <div className="mo__status" style={{ color: Helpers.getStatusColor(item.status).color }}>
            {Helpers.getStatusColor(item.status).text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'FINISHED GOOD(s)',
        width: '250px',
        render: (item) => {
          const { mo_finished_goods } = item;
          return (
            <Fragment>
              {
                mo_finished_goods?.map((rec) => (
                  <div className="link-mo-mrp-sku-name">
                    <Tooltip title={`${rec?.internal_sku_code || ''} - ${rec?.product_sku_name} ${rec?.quantity} ${rec?.uom_info?.uqc?.toProperCase()}`}>
                      {rec?.product_sku_name ? (
                        <Link to={`/inventory/product/view/${rec?.product_sku_id}`} target="_blank">
                          {`${rec?.internal_sku_code || ''} - ${rec?.product_sku_name}`}
                        </Link>
                      ) : '-'}
                    </Tooltip>
                  </div>
                ))
              }
            </Fragment>
          );
        },
        responsive: ['md', 'lg', 'xxl'],
      },
      // {
      //   title: 'MATERIAL PLANNING STATUS',
      //   render: (text, record) => (
      //     <div className="mo__status">
      //       {record?.mrp_run_id ? (
      //         <Link to={`/production/planning/view/${record?.mrp_run_id}`} target="_blank">
      //           {record?.mrp_run_number}
      //           {' '}
      //           <FontAwesomeIcon icon={faSquareArrowUpRight} />
      //         </Link>
      //       ) : '-'}
      //     </div>
      //   ),
      //   responsive: ['md', 'lg', 'xxl'],
      // },
      {
        title: 'CREATED DATE',
        render: (text, record) => (
          <div>
            {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'SCHEDULED DATE',
        render: (text, record) => toISTDate(record?.scheduled_date).format('DD/MM/YYYY'),
        responsive: ['md', 'lg', 'xxl'],
      },
      // {
      //   title: 'EST. LEAD TIME',
      //   render: (record) => (
      //     <div>
      //       <H3Text text={(record?.lead_time_in_min ? `${convertMinutesToTime(record?.lead_time_in_min)}` : '00:00:00')} style={{ fontSize: '16px' }} />
      //     </div>
      //   ),
      //   responsive: ['sm', 'md', 'lg', 'xxl'],
      // },
    ];
    moListColumns.push({
      title: '',
      key: 'action',
      className: 'list__actions-column',
      fixed: 'right',
      render: (text, record) => (
        <div className="list__actions">
          <div
            style={{ width: '100%' }}
            className="list__actions-button list__actions-button-dark"
            onClick={() => {
              if (!isRowDisabled(record)) {
                history.push(`/production/manufacturing-orders/view/${record.mo_id}`);
              }
            }}
          >
            View
          </div>
          {user?.tenant_info?.production_config?.addons?.access_restriction?.is_active && (
            <div
              className="list__actions-button"
            >
              {!isRowDisabled(record) ? <UnlockOutlined /> : <LockOutlined />}
            </div>
          )}
        </div>
      ),
      responsive: ['md', 'lg', 'xxl'],
    });
    return moListColumns;
  };

  return (
    <Spin spinning={getMOLoading === true}>
      <div
        className="link-mo-mrp__wrapper"
      >
        <div className="link-mo-mrp__filter-wrapper">
          <div className="ant-row">

            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Department
                </label>
                <SelectDepartment
                  title="Select Department"
                  hideTitle
                  selectedDepartment={selectedDepartment}
                  noDropdownAlign
                  onChange={(value) => {
                    setSelectedDepartment(value?.department_info?.department_id);
                  }}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Sub-Contractor
                </label>
                <PRZSelect
                  value={selectedSeller}
                  onChange={(value) => {
                    setSelectedSeller(value);
                  }}
                  filterOption={false}
                  placeholder="Search by vendor.."
                  onSearch={(val) => {
                    getSellers(val, tenantId, 1, 100);
                  }}
                  style={{ width: '100%' }}
                  showSearch
                  loading={getSellersLoading}
                >
                  <Option key="" value="">All Vendors</Option>
                  {sellers?.sellers?.map((item) => (
                    <Option key={item?.tenant_seller_id} value={item?.seller_id}>
                      {item?.seller_info?.seller_name}
                    </Option>
                  ))}
                </PRZSelect>
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Order Status
                </label>
                <PRZSelect
                  value={selectedStatus}
                  onChange={(value) => {
                    setSelectedStatus(value);
                  }}
                  style={{ width: '100%' }}
                  placeholder="Search by Status.."
                  mode="multiple"
                  maxTagCount="responsive"
                  showSearch={false}
                  options={statusOptions}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Scheduled Date
                </label>
                <H3DateSelector
                  customStyle={{ borderRadius: '3px', width: '100%', marginTop: '-9px' }}
                  startDate={scheduledStartDate}
                  endDate={scheduledEndDate}
                  onDateChange={(date) => {
                    if (date?.length === 2) {
                      setScheduledStartDate(dayjs((date[0])?.valueOf()).format('YYYY-MM-DD'));
                      setScheduledEndDate(dayjs((date[1])?.valueOf()).format('YYYY-MM-DD'));
                    } else {
                      setScheduledStartDate(null);
                      setScheduledEndDate(null);
                    }
                  }}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">
                  Date
                </label>
                <H3DateSelector
                  customStyle={{ borderRadius: '3px', width: '100%', marginTop: '-9px' }}
                  startDate={startDateMomentEpoch}
                  endDate={endDateMomentEpoch}
                  onDateChange={(date) => {
                    if (date?.length === 2) {
                      setStartDateMomentEpoch(dayjs((date[0])?.valueOf()).format('YYYY-MM-DD'));
                      setEndDateMomentEpoch(dayjs((date[1])?.valueOf()).format('YYYY-MM-DD'));
                    } else {
                      setStartDateMomentEpoch(null);
                      setEndDateMomentEpoch(null);
                    }
                  }}
                />
              </div>
            </div>

          </div>
        </div>
        <Button
          onClick={() => {
            handleLinkMo();
          }}
        >
          Search
        </Button>
        <div className="link-mo-mrp__table-wrapper">
          <Table
            title={() => (
              <div className="link-mo-mrp__table-title">
                <H3Text text={`${moData?.length || 0} Production Orders`} className="" />
              </div>
            )}
            bordered
            showHeader
            size="small"
            loading={linkMoToMrpLoading}
            columns={getMoColumns()}
            dataSource={moData?.map((item) => ({ ...item, key: item?.mo_id })) || []}
            scroll={{ x: 'max-content' }}
            pagination={false}
            rowSelection={(window.screen.width > 425) ? {
              onChange: (rowKeys, rows) => {
                setSelectedRowKeys(rowKeys);
                setSelectedRows(rows);
              },
              selectedRowKeys,
              getCheckboxProps: (record) => ({
                disabled: user?.tenant_info?.production_config?.addons?.access_restriction?.is_active && record?.is_restricted && !record?.mo_users?.includes(user?.user_id),
              }),
            } : false}
            rowClassName={(record) => (isRowDisabled(record) ? 'disabled-rows' : '')}
          />
        </div>
      </div>
      <div className="custom-drawer__footer" style={{ width: '100%' }}>
        <div className="ant-col-md-6">
          <Button
            type="primary"
            onClick={() => {
              if (selectedRows?.length > 0) {
                linkMoToMrp({
                  mo_ids: selectedRowKeys,
                  mrp_id: mrpId,
                }, () => {
                  setSelectedRowKeys(null);
                  setSelectedRows(null);
                  callback();
                });
              } else {
                notification.open({
                  type: 'error',
                  message: 'Please select at least one production order.',
                  placement: 'top',
                  duration: 4,
                });
              }
            }}
            loading={linkMoToMrpLoading}
            disabled={linkMoToMrpLoading}
          >
            Add Production Orders
          </Button>
        </div>
      </div>
    </Spin>
  );
};
const mapStateToProps = ({
  UserReducers, MrpV2Reducers, MOReducers, SellerReducers, DepartmentReducers,
}) => ({
  user: UserReducers.user,
  manufacturingOrders: MOReducers.manufacturingOrders,
  getMOLoading: MOReducers.getMOLoading,
  sellers: SellerReducers.sellers,
  getSellersLoading: SellerReducers.getSellersLoading,
  departments: DepartmentReducers.departments,
  linkMoToMrpLoading: MrpV2Reducers.linkMoToMrpLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getMO: (tenantId, moId, status, page, limit, searchKeyword, callback, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp) => dispatch(
    MOActions.getMO(tenantId, moId, status, page, limit, searchKeyword, callback, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp),
  ),
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive)),
  linkMoToMrp: (payload, callback) => dispatch(MrpV2Actions.linkMoToMrp(payload, callback)),
});

LinkManufacturingOrderMrp.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  mrpId: PropTypes.any,
  callback: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LinkManufacturingOrderMrp));
